// axios
import axios from 'axios'

const domain = ""

const instance = axios.create({
  domain
})

delete instance.defaults.headers.common['Expect']
delete instance.defaults.headers.post['Expect']

export default instance